module.exports = __webpack_public_path__ + "media/assets/good_at/heroku-6be1f64720b82808f364350123660b6d.png";